var _path, _circle, _polyline, _line, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.335,27.131c-1.058,0-1.916-.858-1.916-1.916s.858-1.916,1.916-1.916h.665v-4.693h-.665c-1.058,0-1.916-.858-1.916-1.916s.858-1.916,1.916-1.916h.665v-2.693c0-.925-.75-1.675-1.675-1.675H4.675c-.925,0-1.675.75-1.675,1.675v17.837c0,.925.75,1.675,1.675,1.675h32.649c.925,0,1.675-.75,1.675-1.675v-2.787h-.665Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.03,
    cy: 24.618,
    r: 2.514
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "14.544 24.618 14.544 14.774 23.748 14.774 23.748 24.618"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32.271,
    y1: 10.407,
    x2: 32.271,
    y2: 31.593
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.234,
    cy: 24.618,
    r: 2.514
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorEntertainment);
export default __webpack_public_path__ + "static/media/indoor-entertainment.b29b67c399692c38fda2cc6c53feecbd.svg";
export { ForwardRef as ReactComponent };